import React from 'react';
import { IconProps } from './types';

export const BadgeNewIcon = (props: IconProps) => {
  const { size = 20, color = 'currentColor', style = {}, classNames = '' } = props;

  return (
    <svg
      className={classNames}
      width={size}
      height={size - 11}
      style={style}
      viewBox='0 0 20 9'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.19 3.66995L1.35 2.11995H1.32V7.92995H0.5V0.949951H1.47L4.02 5.20995L4.86 6.75995H4.89V0.949951H5.71V7.92995H4.74L2.19 3.66995ZM9.43 8.04995C9.08 8.04995 8.76 7.98995 8.47 7.85995C8.19 7.72995 7.95 7.54995 7.74 7.31995C7.54 7.07995 7.38 6.79995 7.27 6.46995C7.16 6.13995 7.11 5.75995 7.11 5.34995C7.11 4.93995 7.16 4.56995 7.27 4.23995C7.38 3.90995 7.54 3.61995 7.74 3.38995C7.95 3.14995 8.19 2.96995 8.47 2.83995C8.76 2.70995 9.08 2.64995 9.43 2.64995C9.78 2.64995 10.09 2.70995 10.36 2.83995C10.63 2.96995 10.87 3.13995 11.06 3.36995C11.25 3.58995 11.4 3.84995 11.5 4.15995C11.61 4.46995 11.66 4.79995 11.66 5.16995V5.54995H7.95V5.78995C7.95 6.00995 7.98 6.21995 8.05 6.40995C8.12 6.59995 8.22 6.75995 8.35 6.89995C8.48 7.03995 8.64 7.14995 8.83 7.22995C9.02 7.30995 9.24 7.34995 9.48 7.34995C9.81 7.34995 10.09 7.26995 10.33 7.11995C10.58 6.96995 10.77 6.74995 10.9 6.45995L11.47 6.86995C11.3 7.21995 11.04 7.50995 10.69 7.72995C10.34 7.93995 9.92 8.04995 9.43 8.04995ZM9.43 3.31995C9.21 3.31995 9.01 3.35995 8.83 3.43995C8.65 3.50995 8.49 3.61995 8.36 3.75995C8.23 3.89995 8.13 4.06995 8.06 4.25995C7.99 4.44995 7.95 4.64995 7.95 4.87995V4.94995H10.8V4.83995C10.8 4.37995 10.67 4.00995 10.42 3.73995C10.17 3.45995 9.84 3.31995 9.43 3.31995ZM12.39 2.76995H13.17L13.72 4.99995L14.27 7.25995H14.29L14.92 4.99995L15.57 2.76995H16.28L16.95 4.99995L17.59 7.25995H17.61L18.14 4.99995L18.7 2.76995H19.45L18.08 7.92995H17.09L16.37 5.44995L15.92 3.87995H15.9L15.46 5.44995L14.74 7.92995H13.77L12.39 2.76995Z'
        fill={color}
      />
    </svg>
  );
};
